export const styles = theme => ({
    topMargin: {
        marginTop: theme.spacing(2)
    },
    card: {
        height: 155,        
        marginBottom: theme.spacing(4),
        fload: "left" as const,
        marginRight: theme.spacing(1)
    },
    cardTitle: {
        paddingBottom: theme.spacing(2),
    },
    paymentError: {
        color: "red"
    },
});
